import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Tooltip from 'gnos-tooltip'

import './style.scss'

export default class Input extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        input: PropTypes.object.isRequired,
        label: PropTypes.string,
        meta: PropTypes.object.isRequired,
        placeholder: PropTypes.string,
        showError: PropTypes.bool,
        showErrorBorder: PropTypes.bool,
        showLabel: PropTypes.bool,
        type: PropTypes.string,
    }

    static defaultProps = {
        disabled: false,
        label: 'label',
        placeholder: '',
        showError: true,
        showErrorBorder: false,
        showLabel: true,
        type: 'text',
    }

    render() {
        const {
            input,
            label,
            placeholder,
            type,
            disabled,
            showError,
            showErrorBorder,
            showLabel,
            meta: { touched, error },
        } = this.props

        return (
            <div className={'form-input'}>
                {showLabel && (
                    <label htmlFor={input.name} style={{ visibility: label === 'label' ? 'hidden' : 'visible' }}>
                        {label}
                    </label>
                )}
                <div className={cx('input-wrap', showErrorBorder && touched && error && 'error-border')}>
                    <input {...input} name={input.name} placeholder={placeholder} type={type} disabled={disabled} />
                    {showError && touched && error && (
                        <div className={'error'}>
                            <Tooltip id={`form_input_${input.name}`} content={error} onlyTruncated>
                                <span>{error}</span>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
